<template>
  <div class="layout-frame">
    <div v-if="tokenInQuery">
      <PageIntro :title="t('signUp.finishTitle')" :subtitle="t('signUp.finishSubtitle')" />
      <FinishSignUpForm />
    </div>
    <div v-else>
      <PageIntro :title="t('signUp.title')" :subtitle="t('signUp.subtitle')" />
      <!-- <SignUpForm /> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// Components
// import SignUpForm from '@modules/SignUpForm.vue';
import FinishSignUpForm from '@modules/FinishSignUpForm/FinishSignUpForm.vue';
import PageIntro from '@modules/PageIntro.vue';
import { storeToRefs } from 'pinia';
import { useAccountStore } from '@stores/account.store';

const { t } = useI18n();

// can this be simply accountStore.tokenInQuery and use that in template?
const accountStore = useAccountStore();
const { tokenInQuery } = storeToRefs(accountStore);
</script>
